module.exports = __webpack_public_path__ + "static/logo-small-black.f47f7ce2b7626ae3a6069539a19eb21e.png";